import { useHotkeys } from "react-hotkeys-hook";
import AccentButton from "~/designSystem/components/Buttons/AccentButton";
import SecondaryButton from "~/designSystem/components/Buttons/SecondaryButton";
import Tooltip from "~/designSystem/components/Tooltip";

import { useGlobalNewOpportunityModalContext } from "../context";
import { useGlobalCreateOpportunityStore } from "../store";
import { checkFormHasValueWithoutPrePopulatedFields } from "../utils";

export default function Footer() {
  const setIsSaveAndNewMode = useGlobalCreateOpportunityStore(
    state => state.setIsSaveAndNewMode,
  );
  const isSaveAndNewMode = useGlobalCreateOpportunityStore(
    state => state.isSaveAndNewMode,
  );

  const { form } = useGlobalNewOpportunityModalContext();
  const setIsConfirmCloseForm = useGlobalCreateOpportunityStore(
    state => state.setIsConfirmCloseForm,
  );
  const setIsOpenGlobalCreateOpportunity = useGlobalCreateOpportunityStore(
    state => state.setIsOpenGlobalCreateOpportunity,
  );
  const isOpportunityCreating = useGlobalCreateOpportunityStore(
    state => state.isOpportunityCreating,
  );

  const onCancel = () => {
    const hasValue = checkFormHasValueWithoutPrePopulatedFields(form);
    if (!!hasValue) {
      setIsConfirmCloseForm(true);
    } else {
      setIsOpenGlobalCreateOpportunity(false);
      setIsSaveAndNewMode(false);
    }
  };

  useHotkeys("meta+enter", () => {
    setIsSaveAndNewMode(false);
    form?.submit();
  });

  return (
    <div className="w-full flex justify-end p-3 gap-2">
      <SecondaryButton
        onClick={onCancel}
        shortcutKey={{
          keys: [{ type: "text", value: "Esc" }],
          variant: "stack",
        }}
        label="Cancel"
      />
      <Tooltip contentText="Add this opportunity and create another one">
        <SecondaryButton
          onClick={() => {
            setIsSaveAndNewMode(true);
            form?.submit();
          }}
          loading={isOpportunityCreating && isSaveAndNewMode}
          label="Save & New"
        />
      </Tooltip>
      <Tooltip contentText="Add this opportunity">
        <AccentButton
          loading={isOpportunityCreating && !isSaveAndNewMode}
          shortcutKey={{
            variant: "stack",
            keys: [
              { type: "letter", value: "⌘" },
              { type: "letter", value: "↵" },
            ],
          }}
          onClick={() => {
            setIsSaveAndNewMode(false);
            form?.submit();
          }}
          label="Create Opportunity"
        />
      </Tooltip>
    </div>
  );
}
